/* eslint-disable */
import React, { useState } from 'react';
import './EclipseReport.css';
import DeorbitAnalysisGraph from './DeorbitAnalysisGraph';

const Report = ({ report }) => (
  <div className="report-container-deorbit">
    {report?.map((item) => {
      switch (item.type) {
        case 'Spaceobject':
          return renderSpaceobject(item);
        case 'Plane':
          return renderPlane(item);
        case 'Satellite':
          return renderSatellite(item, item.type);
        default:
          return null;
      }
    })}
  </div>
);

const renderSpaceobject = (spaceobject) => (
  <div key={spaceobject.spaceobjectId} className="spaceobject-container">
    <h5>{spaceobject.spaceobjectName}</h5>
    {spaceobject.planes.map((plane) => renderPlane(plane))}
  </div>
);

const renderPlane = (plane) => (
  <div key={plane.planeId} className="plane-container">
    <div className="plane-header position-relative">
      <span className='position-absolute'>{plane.planeName}</span>
      {renderSatelliteDropdown(plane.satellites)}
    </div>
  </div>
);

const renderSatelliteDropdown = (satellites) => {
  const [selectedSatellite, setSelectedSatellite] = useState(satellites[0]);

  const handleSatelliteChange = (event) => {
    const selectedSatelliteId = event.target.value;
    const selectedSatellite = satellites.find((sat) => sat.satelliteId === selectedSatelliteId);
    setSelectedSatellite(selectedSatellite);
  };

  const showSatelliteTitle = satellites.length === 0;

  return (
    <div className=''>
      <div className="satellite-dropdown-container">
        {showSatelliteTitle && <label>Select Satellite:</label>}
        <select
          className="satellite-dropdown-eclipse"
          onChange={handleSatelliteChange}
          value={selectedSatellite?.satelliteId || ''}
        >
          {satellites.map((sat) => (
            <option key={sat.satelliteId} value={sat.satelliteId}>
              {sat.satelliteName}
            </option>
          ))}
        </select>
        {selectedSatellite && renderSatellite(selectedSatellite, satellites)}
      </div>
    </div>
  );
};

const renderSatellite = (satellite, reportType) => {

  return (
    <>
    <div key={satellite.satelliteId} className="satellite-container">
      {reportType === 'Satellite' && (
        <h4>{satellite.satelliteName}</h4>
      )}
      <div className="overview-container mb-5">
        {/* <h1>{satellite?.data}</h1> */}
        
        <div className="overview-list">
          <div className="reportDataValues">
            <div className="reportDataValuesLabel">De-orbiting Period </div>
            <div className="reportDataValuesDivNum">{satellite?.['overview']?.['deorbitPeriod']? satellite?.['overview']?.['deorbitPeriod']?.toFixed(2):"-"} years</div>
            <div className="reportDataValuesLabel">Altitude</div>
            <div className="reportDataValuesDivNum">{satellite?.overview.altitude? satellite?.overview.altitude:"-"} km</div>
            <div className="reportDataValuesLabel">De-orbiting Altitude</div>
            <div className="reportDataValuesDivNum">{satellite?.overview?.deorbitingAltitude?satellite?.overview?.deorbitingAltitude:"-"} km</div>
          </div>
        </div>
        <DeorbitAnalysisGraph data={{ height: satellite?.height, time: satellite?.timeline }}/>
      </div>
    </div>
    </>
  );
};

export default Report;
